import { Button } from 'features/components/Button';
import { ROUTE_MAP } from 'features/entry-form-v2/utils/routeMap';
import { useNavigate } from 'react-router-dom';
import { LanguageType } from 'types/enums';
import { useSurveyContext } from '../components/SurveyContext';

export const SurveyInvalidPinPage = () => {
	const { language, surveyId, clearPinCode } = useSurveyContext();
	const dictionary = DICTIONARY[language];
	const navigate = useNavigate();

	const handleTryAgain = () => {
		clearPinCode();
		navigate(ROUTE_MAP.surveys.byId.createPath({ surveyId, language }));
	};

	return (
		<>
			<div className="flex flex-col p-8 sm:pt-12 md:pt-20 md:w-[756px] mx-auto">
				<div className="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6 bg-white rounded-lg shadow-normal">
					<h1 className="text-2xl sm:text-4xl font-semibold">
						{dictionary.invalidPinCode}
					</h1>
					<p className="text-sm sm:text-lg">{dictionary.invalidPinCodeDescription}</p>

					<div className="flex justify-end sm:flex-row gap-3">
						<Button
							text={dictionary.tryDifferentPinCode}
							onClick={handleTryAgain}
							variant="primary"
							className="w-full sm:w-auto"
						/>
					</div>
				</div>
			</div>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		invalidPinCode: 'Invalid pin code',
		invalidPinCodeDescription: 'The pin code you entered is invalid.',
		tryDifferentPinCode: 'Try different pin code'
	},
	[LanguageType.Norwegian]: {
		invalidPinCode: 'Ugyldig pin-kode',
		invalidPinCodeDescription: 'Pin-koden du skrev inn er ugyldig.',
		tryDifferentPinCode: 'Prøv en annen pin-kode'
	}
};
